import { createNavigation } from 'next-intl/navigation';
import { routing } from './routing-definition';

export { routing };

export const { Link, redirect, usePathname, useRouter, getPathname } = createNavigation(routing);
